"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var styles_1 = require("@mui/material/styles");
var Container_1 = __importDefault(require("@mui/material/Container"));
var Box_1 = __importDefault(require("@mui/material/Box"));
var ProductHeroLayoutRoot = (0, styles_1.styled)("section")(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {
            color: theme.palette.common.white,
            position: "relative",
            display: "flex",
            alignItems: "center"
        },
        _b[theme.breakpoints.up("sm")] = {
            height: "93vh",
            minHeight: 500,
            maxHeight: 1300,
        },
        _b);
});
var Background = (0, styles_1.styled)(Box_1.default)({
    position: "absolute",
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    zIndex: -2,
});
function ProductHeroLayout(props) {
    var sxBackground = props.sxBackground, children = props.children;
    return (React.createElement(ProductHeroLayoutRoot, null,
        React.createElement(Container_1.default, { sx: {
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
            } },
            children,
            React.createElement(Box_1.default, { sx: {
                    position: "absolute",
                    left: 0,
                    right: 0,
                    top: 0,
                    bottom: 0,
                    backgroundColor: "common.black",
                    opacity: 0.5,
                    zIndex: -1,
                } }),
            React.createElement(Background, { sx: sxBackground }))));
}
exports.default = ProductHeroLayout;
